export class Role {
    id?: number;
    version?: number;
    name?: string;
    code?: string;
    authorities?: string;
}
